import Vue from 'vue';
import Router from 'vue-router';
import Anvil from './views/Anvil.vue';
import Meta from 'vue-meta'

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Anvil
    },
    {
      path: '/lipi',
      name: 'lipi',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "lipi" */ './views/Lipi.vue')
    },
    // {
    //   path: '/lipi/toc',
    //   name: 'lipi-toc',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "lipi" */ './views/LipiToc.vue')
    // },
    {
      path: '*',
      name: 'error404',
      component: () => import(/* webpackChunkName: "lipi" */ './views/Error404.vue')
    },
  ]
})
